@if (isTireSignal()) {
<!-- NOTE: CASE TIRE -->
<!-- <mat-tab-group animationDuration="0ms"> -->
<!-- NOTE: Tab 1 -->
<!-- <mat-tab label="ค้นหาตามขนาดยาง"> -->

@if(fromProductTire) {
<div class="container-search shadow search-tab-1 top-up search-product">
  <div class="item-search-tab-1 search-tab-1-inside search-product-inside">
    <div class="item-image" style="min-height: 103px">
      <img
        src="../../assets/images/img-tire-specs.webp"
        alt="ค้นหายางตาม หน้ายาง ซีรีย์ยาง ขนาดกะทะล้อ"
        title="ค้นหายางตาม หน้ายาง ซีรีย์ยาง ขนาดกะทะล้อ"
        loading="eager"
      />
    </div>
    <form action="" class="" id="search-by-size">
      <div class="container-select-tab-1">
        <label for="surface" class="font-size-18">หน้ายาง</label>
        <mat-form-field appearance="outline">
          <mat-select
            [(value)]="selectedWidthSignal"
            (selectionChange)="changeSelectedDropdown(ESearchBlockPath.HEIGHT, { width: selectedWidthSignal() })"
            placeholder="ALL"
          >
            <mat-option [value]="defaultOption">{{ defaultOption }}</mat-option>
            @for(list of widthListSignal(); track i; let i = $index) {
            <mat-option [value]="list.value">
              {{ list.value }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <label for="surface" class="font-size-18">ซีรีส์ยาง</label>
        <mat-form-field appearance="outline">
          <mat-select
            [(value)]="selectedHeightSignal"
            (selectionChange)="
              changeSelectedDropdown(ESearchBlockPath.SIZE, { width: selectedWidthSignal(), height: selectedHeightSignal() })
            "
            placeholder="ALL"
          >
            <mat-option [value]="defaultOption">{{ defaultOption }}</mat-option>
            @for(list of heightListSignal(); track i; let i = $index) {
            <mat-option [value]="list.value">
              {{ list.value }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <label for="surface" class="font-size-18">ขนาดกะทะล้อ</label>
        <mat-form-field appearance="outline">
          <mat-select [(value)]="selectedSizeSignal" placeholder="ALL">
            <mat-option [value]="defaultOption">{{ defaultOption }}</mat-option>
            @for(list of sizeListSignal(); track i; let i = $index) {
            <mat-option [value]="list.value">
              {{ list.value }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </form>
  </div>
  <button mat-fab (click)="onClickSearch(ESearch.SIZE)">
    <mat-icon>search</mat-icon>
  </button>
</div>
<div class="search-filter">
  <form action="">
    <fieldset class="filter-block">
      <mat-form-field appearance="outline">
        <mat-select [(value)]="selectedTypes" placeholder="ประเภทยาง" multiple (selectionChange)="onClickSearch(ESearch.SIZE)">
          @for (type of typesList; track type) {
          <mat-option [value]="type.value">{{ type.value }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-select [(value)]="selectedHighlights" placeholder="จุดเด่น" multiple (selectionChange)="onClickSearch(ESearch.SIZE)">
          @for (highlight of highlightsListOption; track highlight) {
          <mat-option [value]="highlight">{{ highlight }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </fieldset>
  </form>
</div>
}

<!-- </mat-tab> -->

<!-- NOTE: Tab 2 -->
<!-- <mat-tab label="ค้นหาตามรุ่นยาง">
    <div class="container-search">
      <div class="item-search-tab-2">
        <form action="" class="" id="search-by-pattern">
          <div class="container-select-tab-2">
            <label for="surface">ประเภท</label>
            <mat-form-field appearance="outline">
              <mat-select
                [(value)]="selectedTypeSignal"
                (selectionChange)="changeSelectedDropdown(ESearchBlockPath.BRAND, { type: selectedTypeSignal() })"
                placeholder="ALL"
              >
                <mat-option [value]="defaultOption">{{ defaultOption }}</mat-option>
                @for(list of typeListSignal(); track i; let i = $index) {
                <mat-option [value]="list.value">
                  {{ list.value }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <label for="surface">ยี่ห้อ</label>
            <mat-form-field appearance="outline">
              <mat-select
                [(value)]="selectedBrandSignal"
                (selectionChange)="
                  changeSelectedDropdown(ESearchBlockPath.MODEL, { type: selectedTypeSignal(), brand: selectedBrandSignal() })
                "
                placeholder="ALL"
              >
                <mat-option [value]="defaultOption">{{ defaultOption }}</mat-option>
                @for(list of brandListSignal(); track i; let i = $index) {
                <mat-option [value]="list.value">
                  {{ list.value }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <label for="surface">รุ่น</label>
            <mat-form-field appearance="outline">
              <mat-select [(value)]="selectedModelSignal" placeholder="ALL">
                <mat-option [value]="defaultOption">{{ defaultOption }}</mat-option>
                @for(list of modelListSignal(); track i; let i = $index) {
                <mat-option [value]="list.value">
                  {{ list.value }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </form>
      </div>
      <button mat-fab (click)="onClickSearch(ESearch.TYPE)">
        <mat-icon>search</mat-icon>
      </button>
    </div>
  </mat-tab> -->
<!-- </mat-tab-group> -->
@else{
<div class="container-search shadow search-tab-1 top-up">
  <div class="item-search-tab-1 search-tab-1-inside">
    <div class="item-image" style="min-height: 103px">
      <img
        src="../../assets/images/img-tire-specs.webp"
        alt="ค้นหายางตาม หน้ายาง ซีรีย์ยาง ขนาดกะทะล้อ"
        title="ค้นหายางตาม หน้ายาง ซีรีย์ยาง ขนาดกะทะล้อ"
        loading="eager"
      />
    </div>
    <form action="" class="" id="search-by-size">
      <div class="container-select-tab-1">
        <label for="surface" class="font-size-18">หน้ายาง</label>
        <mat-form-field appearance="outline">
          <mat-select
            [(value)]="selectedWidthSignal"
            (selectionChange)="changeSelectedDropdown(ESearchBlockPath.HEIGHT, { width: selectedWidthSignal() })"
            placeholder="ALL"
          >
            <mat-option [value]="defaultOption">{{ defaultOption }}</mat-option>
            @for(list of widthListSignal(); track i; let i = $index) {
            <mat-option [value]="list.value">
              {{ list.value }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <label for="surface" class="font-size-18">ซีรีส์ยาง</label>
        <mat-form-field appearance="outline">
          <mat-select
            [(value)]="selectedHeightSignal"
            (selectionChange)="
              changeSelectedDropdown(ESearchBlockPath.SIZE, { width: selectedWidthSignal(), height: selectedHeightSignal() })
            "
            placeholder="ALL"
          >
            <mat-option [value]="defaultOption">{{ defaultOption }}</mat-option>
            @for(list of heightListSignal(); track i; let i = $index) {
            <mat-option [value]="list.value">
              {{ list.value }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <label for="surface" class="font-size-18">ขนาดกะทะล้อ</label>
        <mat-form-field appearance="outline">
          <mat-select [(value)]="selectedSizeSignal" placeholder="ALL">
            <mat-option [value]="defaultOption">{{ defaultOption }}</mat-option>
            @for(list of sizeListSignal(); track i; let i = $index) {
            <mat-option [value]="list.value">
              {{ list.value }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </form>
  </div>
  <button mat-fab (click)="onClickSearch(ESearch.SIZE)">
    <mat-icon>search</mat-icon>
  </button>
</div>
}

<!-- NOTE: CASE LUBRICANT/BRAKE -->
} @else {
<!-- <mat-tab-group animationDuration="0ms"> -->
<!-- NOTE: Tab 2 -->
<!-- <mat-tab label="ค้นหาตามรุ่น"> -->
<div class="container-default">
  <div class="item-search-tab-2">
    <form action="" class="" id="search-by-pattern">
      <div class="container-select-tab-2">
        <label for="surface">ประเภท</label>
        <mat-form-field appearance="outline">
          <mat-select
            [(value)]="selectedTypeSignal"
            (selectionChange)="changeSelectedDropdown(ESearchBlockPath.BRAND, { type: selectedTypeSignal() })"
            placeholder="ALL"
          >
            <mat-option [value]="defaultOption">{{ defaultOption }}</mat-option>
            @for(list of typeListSignal(); track i; let i = $index) {
            <mat-option [value]="list.value">
              {{ list.value }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <label for="surface">ยี่ห้อ</label>
        <mat-form-field appearance="outline">
          <mat-select
            [(value)]="selectedBrandSignal"
            (selectionChange)="changeSelectedDropdown(ESearchBlockPath.MODEL, { type: selectedTypeSignal(), brand: selectedBrandSignal() })"
            placeholder="ALL"
          >
            <mat-option [value]="defaultOption">{{ defaultOption }}</mat-option>
            @for(list of brandListSignal(); track i; let i = $index) {
            <mat-option [value]="list.value">
              {{ list.value }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <label for="surface">รุ่น</label>
        <mat-form-field appearance="outline">
          <mat-select [(value)]="selectedModelSignal" placeholder="ALL">
            <mat-option [value]="defaultOption">{{ defaultOption }}</mat-option>
            @for(list of modelListSignal(); track i; let i = $index) {
            <mat-option [value]="list.value">
              {{ list.value }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </form>
  </div>
  <button mat-fab (click)="onClickSearch(ESearch.TYPE)">
    <mat-icon>search</mat-icon>
  </button>
</div>
<!-- </mat-tab> -->
<!-- </mat-tab-group> -->
}
